'use client';

import { ComponentPropsWithRef, ComponentRef, forwardRef } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@ecom/helper-react-class-combine';

type CheckboxProps = ComponentPropsWithRef<typeof CheckboxPrimitive.Root> & {
  error?: boolean;
};

export const Checkbox = forwardRef<ComponentRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, defaultChecked, error = false, onCheckedChange, ...props }, ref) => {
    return (
      <CheckboxPrimitive.Root
        className={cn(
          'disabled:bg-background-subtle border-border-muted block h-6 w-6 border focus:border-white disabled:pointer-events-none',
          error &&
            'focus-visible:ring-error/20 border-error hover:border-error focus-visible:border-error focus-visible:hover:border-error disabled:border-border-muted',
          className,
        )}
        defaultChecked={defaultChecked}
        onCheckedChange={onCheckedChange}
        ref={ref}
        {...props}
      >
        <CheckboxPrimitive.Indicator className='flex shrink-0 items-center justify-center'>
          <Check absoluteStrokeWidth className='stroke-text-muted' size={13} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    );
  },
);

Checkbox.displayName = 'Checkbox';
